class InvalidDocChangeTypeError extends Error {
  constructor(docChangeType) {
    super(docChangeType);
    this.name = 'InvalidDocChangeTypeError';
    this.message = `Unrecognized doc change type: ${docChangeType}`;
  }
}

class UnrecognizedColumnTypeError extends Error {
  constructor(type) {
    super(type);
    this.name = 'UnrecognizedColumnTypeError';
    this.message = `Unrecognized custom column type: ${type}`;
  }
}

export { InvalidDocChangeTypeError, UnrecognizedColumnTypeError };
